import { render, staticRenderFns } from "./DashboardPlatform.vue?vue&type=template&id=0ad9837b"
import script from "./DashboardPlatform.vue?vue&type=script&lang=js"
export * from "./DashboardPlatform.vue?vue&type=script&lang=js"
import style0 from "./DashboardPlatform.vue?vue&type=style&index=0&id=0ad9837b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports